import * as React from 'react';

import {HelpButton} from '../../help/help-button';

type Props = {
    title: string;
    onClick: () => void;
};

export function HeaderWithHelp(props: Props) {
    return (
        <div className='flex align-center'>
            {props.title}
            <HelpButton
                // @ts-expect-error
                onClick={(e: React.SyntheticEvent<any>) => {
                    // don't sort the column on help click
                    e.stopPropagation();
                    props.onClick();
                }}
            />
        </div>
    );
}
